/// <reference types="./QueryFunctions.d.ts" />
import { notOk, ok } from '@dossierhq/core';
import { withQueryPerformance } from './utils/withQueryPerformance.js';
async function queryCommon(database, context, queryOrQueryAndValues, errorConverter) {
    const { text, values } = typeof queryOrQueryAndValues === 'string'
        ? { text: queryOrQueryAndValues, values: undefined }
        : queryOrQueryAndValues;
    const queryAndConvert = async () => {
        try {
            const rows = await withQueryPerformance(context, text, () => database.adapter.query(context, text, values));
            return ok(rows);
        }
        catch (error) {
            if (errorConverter) {
                return errorConverter(error);
            }
            return notOk.GenericUnexpectedException(context, error);
        }
    };
    if (context.transaction) {
        return queryAndConvert();
    }
    const mutexStartTime = performance.now();
    return database.mutex.withLock(context, () => {
        const duration = performance.now() - mutexStartTime;
        context.databasePerformance?.onMutexAcquired(duration);
        return queryAndConvert();
    });
}
export async function queryRun(database, context, queryOrQueryAndValues, errorConverter) {
    const { text, values } = typeof queryOrQueryAndValues === 'string'
        ? { text: queryOrQueryAndValues, values: undefined }
        : queryOrQueryAndValues;
    const queryAndConvert = async () => {
        try {
            const changes = await withQueryPerformance(context, text, () => database.adapter.run(context, text, values));
            return ok(changes);
        }
        catch (error) {
            if (errorConverter) {
                return errorConverter(error);
            }
            return notOk.GenericUnexpectedException(context, error);
        }
    };
    if (context.transaction) {
        return queryAndConvert();
    }
    const mutexStartTime = performance.now();
    return database.mutex.withLock(context, () => {
        const duration = performance.now() - mutexStartTime;
        context.databasePerformance?.onMutexAcquired(duration);
        return queryAndConvert();
    });
}
export async function queryNoneOrOne(database, context, query, errorConverter) {
    const result = await queryCommon(database, context, query, errorConverter);
    if (result.isError()) {
        return result;
    }
    const rows = result.value;
    if (rows.length === 0) {
        return ok(null);
    }
    if (rows.length !== 1) {
        return notOk.Generic(`Expected 0-1 rows, got ${rows.length}`);
    }
    return ok(rows[0]);
}
export async function queryOne(database, context, query, errorConverter) {
    const result = await queryCommon(database, context, query, errorConverter);
    if (result.isError())
        return result;
    const rows = result.value;
    if (rows.length !== 1) {
        return notOk.Generic(`Expected 1 row, got ${rows.length}`);
    }
    return ok(rows[0]);
}
export async function queryMany(database, context, query, errorConverter) {
    const result = await queryCommon(database, context, query, errorConverter);
    return result;
}
//# sourceMappingURL=QueryFunctions.js.map